import { render, staticRenderFns } from "./PosKeyboard.vue?vue&type=template&id=0620773c&scoped=true"
import script from "./PosKeyboard.vue?vue&type=script&lang=js"
export * from "./PosKeyboard.vue?vue&type=script&lang=js"
import style0 from "./PosKeyboard.vue?vue&type=style&index=0&id=0620773c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0620773c",
  null
  
)

export default component.exports